const reportInfo = {
	banner: [{
		tips:'我的报告详情',
		title:'我的报告详情',
		content:'',
		img: require('@/assets/img/index/EPD_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],
	label:{
		info_tips:'申请信息',
		flow_tips:'流程信息',
		down_tips:'下载',
		ck_tips:'参考资料',
		csbz_tips:'环境绩效声明参数及标准',
		wxzz_tips:'文献著作',
		yj_tips:'意见',
		jl_tips:'结论',
		bgmb_tips:'报告模板',
		tjzl_tips:'已提交资料',
		bczl_tips:'已补充资料',
		sjModel:'数据模板',
		pass:'通过',
		refused:'不通过',
		empty:'暂无相关信息',
		submit:'提交资料',
		supplement:'补充资料',
		companyName:'企业名称',
		sampleName:'产品名称',
		address: '产品生产地址',
		productInfo:'产品描述',
		productCategoryName:'产品种类',
		type:'申请类别',
		serialNo:'注册号',
		publishTime:'发布时间',
		expirationTime:'有效期至',
		licenseId:'工艺流程',
		ticketId:'产品图片',
		b_tips:'上传仅支持jpg和png格式，文件大小不超过5m',
		s_tips:'上传仅支持jpg和png格式，文件大小不超过5m',
		down:'下载开票信息模板',
		submit:'提交资料',
		reset:'重置',
		status:'认证状态'
	},
	placeholder:{
	// 	companyName:'请输入企业名称',
	// 	sampleName:"请输入产品名称",
	// 	address: '请输入产品生产地址',
	// 	productInfo:'请输入产品描述',
	// 	productCategory:'请选择产品种类',
		// type:'请选择申请类别',
	// 	licenseId:'请上工艺流程图',
	// 	ticketId:'请上传产品图片',				
	},
	upload:{
		title:'补充资料',
		label:{
			upload:'资料上传',			
			save:'保 存',
			submit:'提 交',
			concel:'取 消'
		}
	},
	submitFile:{
		title:'提交资料',
			label:{
				production:'生产报表',	
				energy:'能耗报表',
				environment:'环境检测报告',
				other:'其他资料',
				save:'保 存',
				submit:'提 交',
				concel:'取 消'
			}
		},
}

 export default reportInfo